import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { ComponentProps } from "react";

export const ContentTitle = ({
    className,
    ...props
}: Omit<ComponentProps<typeof Text>, "variant">) => {
    return (
        <Text
            className={cn("line-clamp-2 break-keep", className)}
            variant="subtitle2"
            color="text.primary"
            {...props}
        />
    );
};
